import { render, staticRenderFns } from "./promiseGoodsMngt.vue?vue&type=template&id=212a4910"
import script from "./promiseGoodsMngt.vue?vue&type=script&lang=js"
export * from "./promiseGoodsMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports